export default __webpack_public_path__ + "static/media/ios-globe.dd3376a6.svg";